import React from "react";
import { Button } from "@pd/pd-ui-kit";
import { ColumnsType } from "antd/es/table";
import type { SortOrder } from "antd/es/table/interface";
import { TFunction } from "i18next";

/** Колонки журнала рассылки, по которым возможна клиентская сортировка */
export const LOGS_EMAIL_SORTABLE_COLUMNS = [
  "id",
  "name",
  "email",
  "subject",
  "status",
  "createdAt",
];

const localeCompare = (a: unknown, b: unknown) =>
  String(a ?? "").localeCompare(String(b ?? ""));

const COMPARATORS: Record<string, (a: any, b: any) => number> = {
  id: (a, b) => localeCompare(a.id, b.id),
  name: (a, b) => localeCompare(a.name, b.name),
  email: (a, b) => localeCompare(a.email, b.email),
  subject: (a, b) => localeCompare(a.subject, b.subject),
  status: (a, b) => localeCompare(a.status, b.status),
  createdAt: (a, b) => (a.createdAtRaw ?? 0) - (b.createdAtRaw ?? 0),
};

/** Кнопка копирования свойств письма в буфер обмена */
const CustomsCell: React.FC<{ value: unknown; copyText: string }> = ({
  value,
  copyText,
}) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(String(value));
  };

  return (
    <Button
      size="small"
      onClick={handleCopy}
      disabled={value == null || value === "null"}
    >
      {copyText}
    </Button>
  );
};

export const getEmailLogsColumns = (
  t: TFunction,
  options: string[],
  sortField?: string,
  sortType?: string,
): ColumnsType<any> =>
  options.map((option) => {
    const comparator = COMPARATORS[option];
    const sortOrder: SortOrder | undefined =
      comparator &&
      sortField === option &&
      (sortType === "ASC" || sortType === "DESC")
        ? sortType === "DESC"
          ? "descend"
          : "ascend"
        : undefined;

    const baseColumn = {
      title: t(`logs.${option}`),
      dataIndex: option,
      key: option,
      ...(comparator ? { sorter: comparator, sortOrder } : {}),
    };

    if (option === "customs") {
      return {
        ...baseColumn,
        render: (value: unknown) => (
          <CustomsCell value={value} copyText={t("logs.copy")} />
        ),
      };
    }

    return {
      ...baseColumn,
      render: (value: any) => <span>{value}</span>,
    };
  });
